import React from 'react'
import '../Sidenav/Side.css'

function Side() {
    return (
        <div className='side'>
            <div className='small'><h5>Men's Clothing</h5></div>
            <div className='small'><h5>Women's Clothing</h5></div>
            <div className='small'><h5>Kid's Clothing</h5></div>
            <div className='small'><h5>Jewelery</h5></div>
            <div className='small'><h5>Cosmetics</h5></div>
            <div className='small'><h5>Bags</h5></div>
            <div className='small'><h5>Watch</h5></div>
        
        </div>
    )
}

export default Side